import { Trans, useTranslation } from 'react-i18next';
import { RouterLink } from '@/common/components/RouterLink/RouterLink';
import { ROUTES } from '@/common/constants/routes';
import { useGetFeatures } from '@/common/integrations/menhir/employee/features/features.hooks';
import { LearningCentreModal } from '@/web/components/LearningCentreModal/LearningCentreModal';
import {
  IconArrowUpRight,
  IconCreditCard,
  IconUtensils,
} from '@coverflex-tech/hypernova';
import css from './MealLearningCentre.module.css';

interface IProps {
  onClose: () => void;
}

export const MealLearningCentre = ({ onClose }: IProps) => {
  const { t } = useTranslation();
  const {
    features: { FF_DISCOUNTS },
  } = useGetFeatures();
  return (
    <LearningCentreModal
      title={t('learning_centre.meal.title')}
      subtitle={t('learning_centre.meal.subtitle')}
      icon={<IconUtensils className={css.mealIcon} />}
      context="meals"
      steps={[
        <>
          <div className={css.methodHeader}>
            <IconCreditCard />
            <div className={css.methodTitle}>
              {t('learning_centre.meal.methods.card.title')}
            </div>
          </div>
          <div className={css.methodDescription}>
            <Trans
              i18nKey={`learning_centre.meal.methods.card.description${
                FF_DISCOUNTS ? '_with_discounts' : ''
              }`}
            >
              &nbsp;
              {FF_DISCOUNTS && (
                <RouterLink href={ROUTES.DISCOUNTS}>
                  <IconArrowUpRight />
                </RouterLink>
              )}
            </Trans>
          </div>
        </>,
      ]}
      onClose={onClose}
    />
  );
};
